module.exports = __webpack_public_path__ + "static/media/img7.42c048ae.jpg";